import React, { PureComponent }  from 'react'
import PropTypes from 'prop-types';
import { cartAdd } from '../../../actions'
import { connect } from 'react-redux'
import _ from 'lodash'

// s4n
import { injectIntl } from "gatsby-plugin-intl"
import ProductPrice from './../../../../Product/price'



const translation = {
  selectVariation: {
    pl: 'Wybierz wariant...',
    en: 'Select variation...',    
  },
  product_attribute__size: {
      pl: 'Czas dostępu',
      en: 'Access time',
      // de: `Kurszugriffszeit`,
      // es: `Tiempo de acceso al curso`,
  },
  product_attribute__date: {
    pl: 'Termin',
    en: 'Date',    
  },
  product_attribute__numberOfPeople: {
    pl: 'Liczba osób',
    en: 'Number of people',    
  },
  product_attribute__numberOfLicenses: {
    pl: 'Liczba licencji',
    en: 'Number of licenses',
  }
}


class Variations extends PureComponent {
  static propTypes = {
    variations: PropTypes.array.isRequired,
    dispatch: PropTypes.func.isRequired,
  }

  constructor (props) {
    super(props);
    this.onChange = this.onChange.bind(this)
    const { variations } = props;
// console.log(variations)

    const { intl } = props;
    const t = intl.formatMessage;
    this.t = t; // this.t = this.t.bind(this);
    this.locale = intl.locale;

    const { entity: defaultVariation } = variations[0];
// console.log('defaultVariation: ', defaultVariation)

    this.state = {
      activeVariation: 1 === variations?.length ? defaultVariation : null,
    }
  }

  onChange({ target: { name, value } }) {
// console.log(name); // product_variations
// console.log(value); // "395" - variationId as string
    const variationId = Number(value);
    const variation = this.props.variations.find(({ entity: variation }) => variation.variationId === variationId)?.entity;
    this.setState({
      activeVariation: variation,
    })
  }

  onAddToCart() {
    const { dispatch } = this.props;
    // console.log(this.state.activeVariation)
    dispatch(cartAdd(this.state.activeVariation))
  }

  render() {
    const t = this.t;
    const { activeVariation = null } = this.state;

    return (
      <React.Fragment>
{/* <pre>{JSON.stringify(activeVariation, null, 4)}</pre> */}
        <h3 className="h3-responsive mb-1">
          <span className="red-text font-weight-bold">
            {activeVariation ? 
              <ProductPrice selectedVariation={activeVariation} printLabel={true} />
              : translation.selectVariation[this.locale]
            }
          </span>
        </h3>

        <div className={`field--name-variations`}>
          <div className={`attribute-widgets form-group`}>
            <div className={`field--item form-type-select`}>
              {/* <div className="panel-title form-required">{translation.product_attribute__size[this.locale]}</div> */}
              <div className="select-wrapper">

                <select 
                  name={`product_variations`} 
                  className={`custom-select`} 
                  onChange={this.onChange} 
                  // value={activeVariation.variationId}
                  defaultValue={activeVariation?.variationId}
                >
                  <option value="">{translation.selectVariation[this.locale]}</option>
                  {this.props.variations.map(({ entity: variation }) => {
// console.log(`variation: `, variation);
                    return (
                      <option key={variation.variationId} value={variation.variationId}>
                        {/* {variation.sku} */}
                        {translation.product_attribute__date[this.locale]}: {variation?.attributeTermin?.entity?.entityLabel},{' '}
                        {translation.product_attribute__size[this.locale]}: {variation?.attributeSize?.entity?.entityLabel},{' '}
                        {translation.product_attribute__numberOfLicenses[this.locale]}: {variation?.attributeLiczbaLicencji?.entity?.entityLabel},{' '}
                        {translation.product_attribute__numberOfPeople[this.locale]}: {variation?.attributeLiczbaOsob?.entity?.entityLabel}
                      </option>
                    )
                  })}
                </select>

              </div>
            </div>

          </div>
          <div className={`field--item add-to-cart`}>
            <button className="button button--primary js-form-submit form-submit btn-success btn" type="button" onClick={this.onAddToCart.bind(this)}>
              <i className="fas fa-cart-plus mr-2" aria-hidden="true"></i> { t({ id: "soft4net_shop_commerce_product_page_add_to_cart" }) }
            </button>
          </div>
        </div>
      </React.Fragment>
    )
  }
}

// export default connect()(Variations);
const VariationsWrapped = injectIntl(Variations);
export default connect()(VariationsWrapped);
